import { useTranslation } from 'react-i18next';
import { CraftAssetDownload } from '#pie/components/craft-asset-download/CraftAssetDownload';
import type { FormCheckboxType } from '#pie/components/form/types';
import { Stack } from '#pie/components/stack/Stack';
import {
  ConsumptionType,
  type CreateDataRequestDto,
  DataType,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { FormCheckbox, ConditionalField, FormText } =
  typedFormFields<CreateDataRequestDto>();

export const ConsumptionTypes = () => {
  //Vebruiksdata
  const { t } = useTranslation('dataRequest');
  const options: FormCheckboxType[] = [
    {
      label: t(`consumption_type.${ConsumptionType.Sjv}`),
      value: ConsumptionType.Sjv,
      renderInput: (
        <CraftAssetDownload title="Aanleveren clusters voorbeeldbestand" />
      ),
      row: true,
      tooltip: t('data_type.tooltip.Sjv'),
    },
    {
      label: t(`consumption_type.${ConsumptionType.Generate}`),
      value: ConsumptionType.Generate,
    },
    {
      label: t(`consumption_type.${ConsumptionType.Consume}`),
      value: ConsumptionType.Consume,
    },
    {
      label: t(`consumption_type.${ConsumptionType.Other}`),
      renderInput: (
        <ConditionalField
          field="consumptionTypeNote"
          condition={(formValue) => {
            return (
              !!formValue('consumptionTypes') &&
              formValue('consumptionTypes')!.includes(ConsumptionType.Other)
            );
          }}
        >
          <FormText
            aria-label={t('other_note')}
            fullWidth
            name="consumptionTypeNote"
            rules={{ maxLength: 100, minLength: 2, required: true }}
          />
        </ConditionalField>
      ),
      value: ConsumptionType.Other,
    },
  ];

  return (
    <ConditionalField
      field="consumptionTypes"
      condition={(formValue) => {
        return (
          !!formValue('dataTypes') &&
          formValue('dataTypes')!.includes(DataType.Consumption)
        );
      }}
    >
      <Stack direction="column" gap="sm">
        <FormCheckbox
          label={t('consumption_types')}
          name="consumptionTypes"
          options={options}
          rules={{ required: true }}
        />
      </Stack>
    </ConditionalField>
  );
};
